import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-brand">
          <div className="footer-brand-top">
            <Link to="/" className="footer-logo">
              <img
                src={process.env.PUBLIC_URL + '/images/musa_logo.png'}
                alt="Musa Electrical"
                className="footer-logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </Link>
            <h3 className="footer-company-name">
              <span className="company-musa">Musa</span> <span className="company-electrical">Electrical</span>
            </h3>
          </div>
          <p>Professional electrical services for your home and business.</p>

          <div className="social-icons">
            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
              <FaFacebookF size={18} />
            </a>
            <a href="https://x.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X (Twitter)">
              <FaXTwitter size={18} />
            </a>
            <a href="https://tiktok.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok">
              <FaTiktok size={18} />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Our Services</h4>
          <ul>
            <li>Electrical Installation</li>
            <li>CCTV & Alarms</li>
            <li>Solar Systems</li>
            <li>Network Installation</li>
            <li>Electrical Designs</li>
            <li>Electronics Repair</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Working Hours</h4>
          <p>Mon - Sat: 8:00 AM - 6:00 PM</p>
          <p>Sunday: Closed</p>
          <p><span className="footer-icon">📞</span> 0796049254</p>
          <p><span className="footer-icon">📧</span> info@musaelectricalkenya.co.ke</p>
          <p><span className="footer-icon">📍</span> Tala, Machakos</p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-row">
          <div className="footer-bottom-left">
            <p>&copy; {new Date().getFullYear()} Musa Electrical. All Rights Reserved.</p>
          </div>
          <div className="footer-bottom-center">
            <p>Powered by <a href="https://www.nawetechltd.co.ke" target="_blank" rel="noopener noreferrer">Nawe Technologies Ltd</a></p>
          </div>
          <div className="footer-bottom-right">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms-conditions">Terms &amp; Conditions</Link>
            <span className="separator">|</span>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
